import { type ImgHTMLAttributes, useState } from 'react';

/**
 * An <img> that says when it has loaded (`data-loaded="true"`). Screen audits and e2e use it to wait for a picture before they
 * take a screenshot: without it a capture races the image, and a golden can record the empty block while every other run sees
 * the picture. It changes nothing visually.
 */
export function LoadedImage(props: ImgHTMLAttributes<HTMLImageElement>) {
  const [loaded, setLoaded] = useState(false);
  return (
    // biome-ignore lint/a11y/useAltText: the caller passes `alt` through props
    <img
      {...props}
      data-loaded={loaded ? 'true' : 'false'}
      onLoad={(e) => {
        setLoaded(true);
        props.onLoad?.(e);
      }}
    />
  );
}
